import { chakra } from '@chakra-ui/react';
import { AlertCircle } from 'lucide-react';
import { forwardRef, type ReactNode } from 'react';

const Root = chakra('p', {
  base: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1.5',
    margin: 0,
    fontFamily: 'body',
    fontSize: 'sm',
    lineHeight: 'snug',
    color: 'status.danger',
  },
});

export interface FieldErrorProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children?: ReactNode;
  /** Hide the leading icon. */
  hideIcon?: boolean;
}

/** Inline validation message. Announced assertively via role="alert". */
export const FieldError = forwardRef<HTMLParagraphElement, FieldErrorProps>(function FieldError(
  { children, hideIcon, ...rest },
  ref,
) {
  if (children == null || children === '') return null;
  return (
    <Root ref={ref} role="alert" {...rest}>
      {!hideIcon && (
        <chakra.span aria-hidden display="inline-flex" mt="0.5" flexShrink={0}>
          <AlertCircle size={15} strokeWidth={2.25} />
        </chakra.span>
      )}
      {children}
    </Root>
  );
});
